"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHostname = void 0;
const cookie_1 = require("./cookie");
const url_1 = require("./url");
const HOSTNAME_KEY = 'hostname';
const DEFAULT_HOSTNAME = 'www.tecmasolutions.com';
const COOKIE_CONFIG = {
    domain: '.tecmasolutions.com',
    path: '/',
};
function getHostname() {
    if ((0, url_1.isProductionUrl)(window.location.hostname)) {
        return window.location.hostname.indexOf('www.') >= 0
            ? window.location.hostname
            : `www.${window.location.hostname}`;
    }
    const paramHostname = (0, url_1.getUrlParam)(HOSTNAME_KEY);
    if (paramHostname) {
        document.cookie = `${HOSTNAME_KEY}=${paramHostname}; domain=${COOKIE_CONFIG.domain};path=${COOKIE_CONFIG.path};`;
        sessionStorage.setItem(HOSTNAME_KEY, paramHostname);
        return paramHostname;
    }
    for (let i = 0; i < localStorage.length; i++) {
        const localStorageKey = localStorage.key(i);
        if (localStorageKey && localStorageKey.includes(HOSTNAME_KEY)) {
            const localHostname = localStorage.getItem(localStorageKey);
            if (localHostname && localHostname.length > 0) {
                return localHostname;
            }
        }
    }
    return ((0, cookie_1.getCookie)(HOSTNAME_KEY) ||
        sessionStorage.getItem(HOSTNAME_KEY) ||
        DEFAULT_HOSTNAME);
}
exports.getHostname = getHostname;
